export default __webpack_public_path__ + "static/media/icon-elsa.10cba4d0.svg";